module.exports = __webpack_public_path__ + "img/20240710105750420in7.e6f9bbe1.jpg";